<template>
  <div class="mall p_b">
    <div class="top_search d_f ali_c">
      <img src="../assets/images/pic4.png" alt="" class="logo">
      <div class="flex_1 d_f ali_c bw">
        <input type="text" class="flex_1" placeholder="请输入你要搜索的课程名字..." v-model="keyWords">
        <img src="../assets/images/icon5.png" alt="" class="cur_p" @click="$router.push('/RecommendedCourses?title=1&keyWords='+keyWords)">
      </div>
    </div>
    <div class="d_f ali_c m_item">
      <div class="mi_left">
        <div class="d_f ali_c mi_ti" v-for="(item,index) in titleArr" :key="index" :class="acType == (index+1) ? 'ac' : ''" @click="changeType(item,index)">
          <img :src="item.uncheckedIconUrl" alt="" class="_img">
          <img :src="item.iconUrl" alt="" class="ac_img">
          <span>{{item.commodityTypeName}}</span>
        </div>
      </div>
      <div class="flex_1 mi_right">
        <div class="mr_title">{{titleArr[acType-1].commodityTypeName}}</div>
        <van-pull-refresh v-model="loading" @refresh="onRefresh">
          <van-list
            :immediate-check="false"
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <div class="mr_items d_f p_r" v-for="(item,index) in list" :key="index" @click="$router.push('/ProductDetails?commodityId='+item.commodityId)">
              <van-image fit="cover" :src="item.commodityCoverOne"/>
              <div class="flex_1">
                <div class="mrr_t">{{item.commodityName}}</div>
                <div class="tag  blue d_i">主要负责人：{{item.duration}}</div>
                <div class="bottom">
                   <span>可预约</span>
                   <span class="check">查看 <van-icon name="arrow" color="#ff8038" /></span>
                </div>
              </div>
            </div>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>

    <FootTab :ac="2"></FootTab>
  </div>
</template>

<script>
  export default {
    name: "Mall",
    data() {
      return {
        keyWords:'',
        acType:1,
        titleArr:[{}],
        refreshing:false,
        loading:true,
        finished:false,
        list:[],
        params:{
          commodityName:'',
          commodityTypeCode:'',
          recommendFlag:0,
          pageIndex:1,
          pageSize:10,
        },
      }
    },
    created(){
      this.listCommodityType();
    },
    methods: {
      // 根据code获取课程
      listCommodity(){
        this.loading = true;
        this.params.recommendFlag = 0;
        this.$api.listCommoditys(this.params).then(res => {
          this.loading = false;
          if (this.refreshing) {
            this.refreshing = false;
          }
          if(res.data.recordCount){
            this.list = this.list.concat(JSON.parse(JSON.stringify(res.data.rows)));
          }
          let list = res.data.rows;
          if (!list || list.length < this.params.pageSize) {
            this.finished = true;
          }
        })
      },
      // 热门课程
      rmList(){
        this.loading = true;
        let send = {
          commodityName: "",
          mallFlag: 1,
          pageIndex: this.params.pageIndex,
          pageSize: this.params.pageSize,
          recommendFlag: 1,
        };
        this.params.recommendFlag = 1;
        this.params.mallFlag = 1;
        this.$api.listCommodityRecommend(send).then(res => {
          this.loading = false;
          this.params.commodityTypeCode = 'rmkc';
          if (this.refreshing) {
            this.refreshing = false;
          }
          if(res.data.recordCount){
            this.list = this.list.concat(JSON.parse(JSON.stringify(res.data.rows)));
          }
          let list = res.data.rows;
          if (!list || list.length < this.params.pageSize) {
            this.finished = true;
          }
        })
      },
      //获取左侧菜单
      listCommodityType(){
        this.$api.listCommodityType({parentCommodityTypeCode:'gml',mallFlag:'1'}).then(res => {
          console.log(res);

          this.titleArr = res.data;
          this.titleArr.map((item,index) => {
            if(item.commodityTypeCode == this.$route.query.tab){
              this.acType = index+1;
            }
          });
          this.params.commodityTypeCode = this.$route.query.tab || this.titleArr[0].commodityTypeCode;
          if(this.params.commodityTypeCode == 'rmkc'){
            this.rmList()
          }else{
            this.listCommodity();
          }
        })
      },
      //点击左侧分类
      changeType(row,num){
        this.acType = num+1;
        this.params.commodityTypeCode = row.commodityTypeCode;
        this.onRefresh()
      },
      onRefresh(){
        this.list = [];
        this.finished = false;
        this.params.pageIndex = 1;
        if(this.params.commodityTypeCode == 'rmkc'){
          this.rmList()
        }else{
          this.listCommodity();
        }
      },
      onLoad(){
        let me = this;
        if(me.loading) return
        let page = me.params.pageIndex;
        page = page ? page + 1 : 1;
        this.params.pageIndex = page;
        if(this.params.commodityTypeCode == 'rmkc'){
          this.rmList()
        }else{
          this.listCommodity();
        }
      },
    }
  }
</script>

<style scoped lang="scss">
  .mi_right{
    .mr_title{
      margin-bottom: 12px;
      font-size: 18px;
      font-weight: bold;
    }
    padding: 20px 13px 20px 11px;
    box-sizing: border-box;
  }
  .m_item{
    .mi_left{
      .mi_ti{
        &.ac{
          img{
            &.ac_img{
              display: block;
            }
            &._img{
              display: none;
            }
          }
          font-size: 12px;
          font-weight: bold;
          color: #ff8038;
        }
        img{
          margin: 0 10px 0 13px;
          height: auto;
          width: 13px;
          &.ac_img{
            display: none;
          }
        }
        font-size: 11px;
        font-weight: bold;
        color: #AEAEAE;
        height: 52px;
        width: 92px;
      }
      background-color: #F5F5F5;
    }
    >div{
      height: 100%;
      overflow-y: auto;
    }
    height: calc(100% - 50px);
  }
  .top_search{
    .flex_1.bw{
      img{
        width: 18px;
        height: 18px;
      }
      input{
        border: none;
        outline: none;
        font-size: 13px;
        font-weight: bold;
        color: #333333;
        &::placeholder{
          color: #D0D0D0;
        }
      }
      padding: 0 6px 0 27px;
      height: 29px;
      background: #FFFFFF;
      border-radius: 15px;
    }
    .logo{
      width: 68px;
      height: 14px;
      margin-right: 13px;
    }
    height: 50px;
    box-sizing: border-box;
    padding: 11px 25px 10px 13px;
    background-color: #ff8038;
  }
  .blue{
    background: #24bddd;
  }
  .bottom{
    display: flex;
    span{
      display: block;
      font-size: 10px;
      color: #aaaaaa;
    }
    .check{
      margin-left: auto;
      color: #ff8038;
      i{
        position: relative;
        top: 1.5px;
      }
    }
  }
</style>
